module.exports = __webpack_public_path__ + "img/kf-logo.7b1a4d61.png";